import { useCallback, useMemo } from 'react';
import getDealerAddresses from '../../api/services/getDealerAddresses';
import SelectWithFetch from './SelectWithFetch';

// label Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ñ Ð±ÑÐºÐ° Ð³Ð¾ÑÐ¾Ð²Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¾Ð¹ â Â«Kia DOSCAR, ÑÐ». ÐÐ»ÐµÐ±ÐµÐºÐ¾Ð²Ð°, 10/1Â».
// ÐÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÑÐ¶ÐµÐ½ Ð°Ð´ÑÐµÑ, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐºÐ¸.
const formatOption = (item) => ({ value: item.id, label: item.label });

/**
 * @param {number} typeId â Ð½Ð°Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÑÐ¾ÑÐºÐ¸: 3 ÑÐµÑÐ²Ð¸Ñ (Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ), 1 ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð².
 * @param {number} markId â Ð¼Ð°ÑÐºÐ° Ð·Ð°Ð¿Ð¸ÑÐ¸, ÐºÐ¾Ð³Ð´Ð° Ð¾Ð½Ð° Ð¸Ð·Ð²ÐµÑÑÐ½Ð° Ð·Ð°ÑÐ°Ð½ÐµÐµ (ÐºÐ°ÑÑÐ¾ÑÐºÐ°
 *   ÑÐ¶Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸). Ð ÑÐ¾ÑÐ¼Ð°Ñ, Ð³Ð´Ðµ Ð¼Ð°ÑÐºÑ Ð²ÑÐ±Ð¸ÑÐ°ÑÑ ÑÑÑ Ð¶Ðµ, Ð¿Ð¾Ð»Ðµ Ð¾Ð±ÑÑÐ²Ð»ÑÑÑ
 *   Ñ dependency: 'mark' Ð¸ Ð¼Ð°ÑÐºÐ° Ð¿ÑÐ¸ÐµÐ·Ð¶Ð°ÐµÑ Ð² dependantValue.
 */
const SelectServiceAddress = ({
  typeId,
  markId,
  dependantValue,
  dependencyAccessor = (obj) => obj,
  ...props
}) => {
  const mark = useMemo(
    () => markId ?? dependencyAccessor(dependantValue),
    [markId, dependantValue, dependencyAccessor]
  );
  const fetch = useCallback(() => getDealerAddresses({ typeId, markId: mark }), [typeId, mark]);

  return <SelectWithFetch fetch={fetch} formatOption={formatOption} resetKey={mark} {...props} />;
};

export default SelectServiceAddress;
